import { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../../utils'
import styles from './Badge.module.css'

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'error' | 'warning'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
  /** Render as a leading-dot status indicator instead of a filled pill */
  dot?: boolean
  /** Monospace count-chip styling */
  count?: boolean
  children: ReactNode
}

export function Badge({ tone = 'neutral', dot = false, count = false, className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(styles.badge, styles[tone], dot && styles.dot, count && styles.count, className)}
      {...rest}
    >
      {children}
    </span>
  )
}
